import { FC } from "react";
import { useEnvironmentsListItem } from "./EnvironmentsListItem.hook";
import { IEnvironment } from "../../../../interfaces";

interface Props {
  env: IEnvironment;
  index: number;
}

export const EnvironmentsListItem: FC<Props> = ({ env, index }) => {
  const { intenalVersion, prodVersion } = useEnvironmentsListItem(
    env?.uat || (env?.url as string),
    env?.prod
  );

  const prodLinkClass = env?.isLive ? "live" : "disabled";
  const internalEnvUrl = env?.uat || env?.url;

  return (
    <tr className="environment-item">
      <td>{index + 1}</td>
      <td>{env?.name}</td>
      <td>
        <span
          className={
            env?.cluster?.trim()
              ? "environment-cluster"
              : "environment-cluster environment-cluster-single"
          }
        >
          {env?.cluster?.trim() || "Single-tenant"}
        </span>
      </td>
      <td className="environment-item-action">
        {internalEnvUrl && (
          <a
            className="environment-item-link"
            href={internalEnvUrl}
            target="_blank"
            rel="noreferrer"
          >
            Click me
          </a>
        )}
      </td>
      {env?.uatDate && <td>{env?.uatDate}</td>}
      <td>{intenalVersion}</td>
      <td className="environment-item-action">
        {env?.prod && (
          <a
            className={`environment-item-link ${prodLinkClass}`}
            href={env?.prod}
            target="_blank"
            rel="noreferrer"
          >
            Click me
          </a>
        )}
      </td>
      <td>{env?.prodDate}</td>
      <td>{prodVersion}</td>
      <td>{env?.rm}</td>
      <td className="environment-item-priority">{env?.priority}</td>
      <td className="environment-item-additional-domains">
        {env?.additionalDomains?.length === 0 && "No additional domains"}
        {env?.additionalDomains?.map((additionalDomain) => (
          <a
            key={additionalDomain}
            href={additionalDomain}
            target="_blank"
            rel="noreferrer"
          >
            {additionalDomain}
          </a>
        ))}
      </td>
    </tr>
  );
};
